import { render, staticRenderFns } from "./swap-battery-button.vue?vue&type=template&id=b5589c6a&scoped=true&lang=pug&"
import script from "./swap-battery-button.vue?vue&type=script&lang=js&"
export * from "./swap-battery-button.vue?vue&type=script&lang=js&"
import style0 from "./swap-battery-button.vue?vue&type=style&index=0&id=b5589c6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5589c6a",
  null
  
)

export default component.exports